import { render, staticRenderFns } from "./unitAdd.vue?vue&type=template&id=84407172&scoped=true"
import script from "./unitAdd.vue?vue&type=script&lang=js"
export * from "./unitAdd.vue?vue&type=script&lang=js"
import style0 from "./unitAdd.vue?vue&type=style&index=0&id=84407172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84407172",
  null
  
)

export default component.exports